import styled from "styled-components";

export const Text = styled.span``;

export const View = styled.div``;
